export default __webpack_public_path__ + "i18n/translations/translation.da1be0ce.json";